import React, { useEffect, useState } from "react";
import styles from "./timeLine.module.scss";
import { Checkbox } from "src/components/input";
import { ReportState } from "../..";
import DatePicker from "react-datepicker";
import moment from "moment";
import { get } from "lodash";

interface TimeLineProps {
  reportState: ReportState;
  onReportStateChange: (state: ReportState) => void;
}

const TimeLine: React.FC<TimeLineProps> = ({
  reportState,
  onReportStateChange,
}) => {

  useEffect(() => {
    setDateRange([reportState.startDate, reportState.endDate]);
  }, [reportState.startDate, reportState.endDate]);

  const getStartDate = (label: String) => {
    let start = moment().startOf("day");
    switch (label) {
      case "Yesterday":
        start = moment().subtract(1, "days").startOf("day");
        break;
      case "7 days":
        start = moment().subtract(7, "days").startOf("day");
        break;
      case "30 days":
        start = moment().subtract(30, "days").startOf("day");
        break;
      case "90 days":
        start = moment().subtract(90, "days").startOf("day");
        break;
    }

    return start.toDate();
  }

  const Days = ["Today", "Yesterday", "7 days", "30 days", "90 days"];

  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([reportState.startDate, reportState.endDate]);

  const [startDate, endDate] = dateRange;

  const isChecked = (label: string) => {
    const now = moment().endOf("day");
    let start = getStartDate(label);

    return (
      moment(startDate).startOf("day").isSame(moment(start).startOf("day")) &&
      moment(endDate).endOf("day").isSame(now, "day")
    );
  };

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setDateRange([start ?? undefined, end ?? undefined]);

    if (start && end) {
      onReportStateChange({
        ...reportState,
        startDate: moment(start).startOf("day").toDate(),
        endDate: moment(end).endOf("day").toDate(),
      });
    }
  };

  const handlePresetClick = (label: string | null) => {
    let start = getStartDate(label || "Today");
    let end = moment().endOf("day").toDate();

    setDateRange([start, end]);
    onReportStateChange({
      ...reportState,
      startDate: start,
      endDate: end,
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.daysContainer}>
        {Days.map((label) => (
          <div key={label} className={styles.days}>
            <div className={styles.day}>{label}</div>
            <Checkbox
              checked={isChecked(label)}
              onChange={() => handlePresetClick(label)}
            />
          </div>
        ))}
      </div>
      <span className={styles.datePickerContainer}>
        <DatePicker
          key={`${reportState.startDate.getTime()}-${reportState.endDate.getTime()}`}
          selected={startDate}
          onChange={handleDateChange}
          startDate={startDate}
          endDate={endDate}
          dateFormat="dd MMM yyyy"
          maxDate={new Date()}
          selectsRange
          inline={true}
        />
      </span>
    </div>
  );
};

export default TimeLine;
